import request from '@/utils/request';
import store from '../store';
import { refreshToken } from '@/api/login';
import { getToken, setToken, getRefreshToken } from '@/utils/auth';
import { MessageBox } from 'element-ui';

var isRefreshing = true; // 刷新token开关，防止重复请求
var subscribers = []; // Promise回调函数集合，用于同时多请求产生token失效后只有等刷新token的函数执行完毕，才会批量执行这些Promise函数，返回请求结果

function onAccessTokenFetched() {
  subscribers.forEach((callback) => {
    callback();
  });
  subscribers = [];
}

function addSubscriber(callback) {
  subscribers.push(callback);
}

function http(reqUrl, op, cb) {
  return request({
    url: reqUrl,
    headers: op.headers ? op.headers : {
      'Content-Type': 'application/json'
    },
    responseType:op.responseType||undefined,
    method: op.method,
    data: op.data,
    params: op.params
  }).then(res => {
    // 执行调用http()传入的回调函数，然后再执行成功的then()
    if (cb) {
      cb(res);
    }
    // 返回axios请求返回结果给上级then
    return res;
  }).catch(error => {
    // 401且headers['www-authenticate']存在过期信息则认为请求携带的token过期
    // console.log('http.js',error);
    if (error.response && error.response.status === 401 && error.response.headers['www-authenticate'] && error.response.headers['www-authenticate'].indexOf('expired') !== -1) {
      // 刷新token的函数
      if (isRefreshing) {
        refreshToken(getToken(), getRefreshToken()).then(response => {
          const data = response.new_token;
          // 更新token
          setToken(data.access_token);
          onAccessTokenFetched();
          isRefreshing = true;
        }).catch(() => {
          // token刷新失败-》退出登录
          store.dispatch('FedLogOut').then(() => {
            MessageBox.alert('登录状态失效：您的账号在其他地点登录', '提示', {
              confirmButtonText: '知道了',
              callback: action => {
                location.reload();// 为了重新实例化vue-router对象 避免bug
              }
            });
          });
        });
      }
      isRefreshing = false;
      const retryOriginalRequest = new Promise((resolve) => {
        addSubscriber(() => {
          resolve(http(reqUrl, op, cb));
        });
      });
      return retryOriginalRequest;
    } else {
      return Promise.reject(error);
    }
  });
}


http.postJson=function(url,data){

    return new Promise((re,rj)=>{
        http(url,{
            data:data,
            method:"post",
            headers:{
                'Content-Type': 'application/json'
            }
        },(r)=>{
            re(r);
        });
    });
}

export default http;



// WEBPACK FOOTER //
// ./src/utils/http.js